module.exports = __webpack_public_path__ + "static/media/operador-logo-dentalprev.7b89d55b.svg";